import styled from "styled-components";

export const ShiftCardsContainer = styled.div`
  & > div:first-child {
    box-shadow: 0 15px 50px 0 rgba(79, 104, 145, 0.1);
    -webkit-box-shadow: 0 15px 50px 0 rgba(79, 104, 145, 0.1);
    -moz-box-shadow: 0 15px 50px 0 rgba(79, 104, 145, 0.1);
    
    display: flex;
    flex-direction: column;
  }
  
  & > div:not(:first-child) {
    box-shadow: 0 5px 10px 0 rgba(79, 104, 145, 0.07);
    -webkit-box-shadow: 0 5px 10px 0 rgba(79, 104, 145, 0.07);
    -moz-box-shadow: 0 5px 10px 0 rgba(79, 104, 145, 0.07);
  }
  
  height: calc(100% - 2rem);
`;

export const ShiftCardWrapper = styled.div`
  border-radius: 12px;
  background-color: #FDFDFE;
  width: 100%;
  direction: rtl;
  margin-bottom: 2rem;
  z-index: 9;
  position: relative;
  padding: 2.5rem 2rem;
  height: 100%;
  
  @media (max-width: 992px) {
    overflow: hidden;
    padding: 0;
    
    & > div:first-child {
      padding: .5rem;
    }
  }
`;

export const ExtraShiftCard = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 12px;
  background-color: #FDFDFE;
  left: 4px;
  top: 6px;
`;

export const ShiftInfo = styled.div`
  border-bottom: 1px solid #A8D6CC;
  text-align: center;

  @media (max-width: 992px) {
   border-bottom: none;
  }
`;

export const ShiftSubInfo = styled.div`
  @media (max-width: 992px) {
    border-top: 1px solid #A8D6CC;
  }
`;

export const ShiftTime = styled.h3`
  color: var(--dark-gray-color);
  font-size: 1.2rem;
  text-align: center;
  margin: 0;

  @media (max-width: 1400px) {
    font-size: 1.05rem;
  }
  
  @media (max-width: 968px) {
    color: var(--success-color);
    font-size: .9rem;
  }
`;

export const ShiftPrice = styled.p`
  color: var(--gray-color);
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    font-size: 3.2rem;
    color: var(--dark-gray-color);
  }

  @media (max-width: 1400px) {
    span {
      font-size: 2.8rem;
    }
  }
  
  @media (max-width: 968px) {
    span {
      font-size: 2.6rem;
    }
  }
`;

export const PharmacyName = styled.p`
  font-size: 1rem;
  color: var(--dark-gray-color);

  @media (max-width: 968px) {
    font-size: .8rem;
    text-align: right;
    padding-top: 1.5rem;
  }
`;

export const PharmacyLoc = styled.p`
  color: var(--gray-color);
  font-size: .8rem;
  margin-bottom: 0;
  
  i {
    font-size: 1rem;
  }

  @media (max-width: 968px) {
    text-align: right;
    font-size: .72rem;
  }
`;

export const InstantShift = styled.div`
  background-color: var(--danger-color);
  padding: .3rem 1rem;
  color: #FFFFFF;
  font-size: .8rem;
  margin-right: .5rem;
  border-radius: 30px;
`;

export const GreenCircle = styled.div`
  min-width: 17px;
  min-height: 17px;
  background-color: var(--success-color);
  border-radius: 50%;
  margin-left: 10px;
  
  @media (max-width: 992px) {
    min-width: 14px;
    min-height: 14px;
  }
`;

export const SquareCircle = styled.div`
  min-width: 17px;
  min-height: 17px;
  background-color: var(--warning-color);
  border-radius: 4px;
  margin-left: 10px;

  @media (max-width: 992px) {
    min-width: 14px;
    min-height: 14px;
  }
`;

export const StartEndTime = styled.p`
  font-size: .9rem;
  margin-bottom: -2px;

  @media (max-width: 968px) {
    font-size: .75rem;
  }
`;

export const DashedBorder = styled.div`
  border-right: 2px dashed var(--gray-color);
  flex-grow: 1;
  height: 20px;
  width: 10px;
  margin: 5px 7px 5px 0;

  @media (max-width: 968px) {
    margin-right: 6px;
  }
`;

export const ActionShiftCard = styled.div`
  @media (max-width: 968px) {
    width: 100%;
    
    a, button {
      width: 100%;
      border-radius: 0;
      display: block;
      padding:.6rem .1rem;
    }
  }
`;
